import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { useEffect, useRef } from "react"
import { fetchTradingPartners, fetchTransactions, selectDestType, selectEndDate, selectSelectedPartner, selectSocialMarketPartnersFirstLoad, selectStartDate, selectTransactionsEnd, selectTransactionsFirstLoad } from "../model";
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { TransactionsTable } from "./transactions-table";
import { TransactionsFilters } from "./transactions-filters";

export const SocialMarketTransactionPage = () => {
    const isFirstRender = useRef(true)
    const transactionsFirstLoad = useAppSelector(selectTransactionsFirstLoad)
    const partnersFirstLoad = useAppSelector(selectSocialMarketPartnersFirstLoad)
    const dispatch = useAppDispatch()
    const end = useAppSelector(selectTransactionsEnd)
    const observerRef = useRef<HTMLDivElement>(null)
    const partner = useAppSelector(selectSelectedPartner)
    const startDate = useAppSelector(selectStartDate)
    const destType = useAppSelector(selectDestType)
    const endDate = useAppSelector(selectEndDate)

    const observerOptions: IntersectionObserverInit = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    useEffect(() => {
        const handleObserve = (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries
            if (entry?.isIntersecting && !end) {
                dispatch(fetchTransactions())
            }
        }
        const observer = new IntersectionObserver(handleObserve, observerOptions)
        if (observerRef.current) observer.observe(observerRef.current)
        return () => {
            if (observerRef.current) observer.unobserve(observerRef.current)
        }
    }, [observerRef, observerOptions])

    useEffect(() => {
        dispatch(fetchTransactions())
    }, [partner, startDate, endDate, destType])

    useEffect(() => {
        if (transactionsFirstLoad) {
            dispatch(fetchTransactions())
        }
        if (partnersFirstLoad) {
            dispatch(fetchTradingPartners())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container flex-1">
            <PageHeader title="Маркет социальных программ" />
            <div className='flexbox h-full '>
                <PageSubtitle title="Транзакции" />
                <TransactionsFilters />
                <TransactionsTable />
                <div ref={observerRef} id="observer" />
            </div>
        </div>
    )
}